import React, { useState } from "react";
import Navbar from "../components/Layout/Navbar";
import Footer from "../components/Layout/Footer";
import CustomHelmet from "../components/CustomHelmet";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { Container, Card, Accordion } from "react-bootstrap";

export default function Support(props) {
  const [faq, setFaq] = useState(true);
  const [video, setVideo] = useState(false);

  return (
    <div>
      <CustomHelmet page="Support" />
      <div className="wrapper details_banner banner1 position-relative">
        <div className="overlay">
          <Navbar search={true} user={props.user} props={props} />

          <div className="banner">
            <div className=" text-left mt-6 container">
              <h1>HUBSQUARES SUPPORT</h1>
            </div>
          </div>
        </div>
      </div>

      <main className="container mb-5 details">
        <div className="row py-3">
          <div className="col-md-2"></div>
          <div className="col-md-8 justify-content-center row">
            <div
              className={
                faq
                  ? "col-5 support-tab supp-active text-center mx-2 py-2"
                  : "col-5 support-tab  text-center mx-2 py-2"
              }
              onClick={() => {
                setFaq(true);
                setVideo(false);
              }}
            >
              <i className="fa fa-question-circle sup-icon text-dark" />
              <h3>FAQs</h3>
              <p>In depth articles and videos on everything Hubsquares</p>
            </div>
            <div
              className={
                video
                  ? "col-5 support-tab supp-active text-center mx-2 py-2"
                  : "col-5 support-tab  text-center mx-2 py-2"
              }
              onClick={() => {
                setFaq(false);
                setVideo(true);
              }}
            >
              <i className="fa fa-film sup-icon text-dark" />
              <h3>Video</h3>
              <p>Video workshops to help you get started or finished</p>
            </div>
          </div>
          <div className="col-md-2"></div>
        </div>

        <main>
          <Container>
            {faq && (
              <div className="my-5">
                <h3 className="my-2">FAQs for customers</h3>
                <Accordion defaultActiveKey="0">
                  <div className="my-4">
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="0"
                      >
                        Do I need to sign up for an account?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          No, you don't need an account to find businesses but
                          you can subscribe to our mailing list to get notified
                          of new African businesses near you.{" "}
                          <HashLink
                            to="/#section1"
                            className="text-dark text-decoration-none font-italic"
                          >
                            Subscribe here
                          </HashLink>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="1"
                      >
                        Do I need to have an account to contact a
                        seller/business owner?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="1">
                        <Card.Body>
                          No, you don't need to have an account to contact
                          sellers or business owners
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="2"
                      >
                        Where are you located?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="2">
                        <Card.Body>
                          We are an online platform connecting African
                          businesses to Africans in diaspora across the world
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="3"
                      >
                        How do I find a business near me?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="3">
                        <Card.Body>
                          Simply type in your city and location to find
                          businesses near you
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="4"
                      >
                        Do I need to pay before I can contact a seller/business
                        owner?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="4">
                        <Card.Body>
                          Its absolutely free to contact a seller or business
                          owner
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="5"
                      >
                        How do I contact the seller/business owner?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="5">
                        <Card.Body>
                          You can contact the business owner by clicking their
                          contact details or using their social media pages or
                          by visiting their website.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="6"
                      >
                        Why can't I find the contact details of a business on
                        their Hub?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="6">
                        <Card.Body>
                          Only businesses that are subscribed have their contact
                          details visible on their Hub.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="7"
                      >
                        How do I make changes to an order I have already placed?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="7">
                        <Card.Body>
                          Please contact the business owner directly for any
                          changes to orders or services provided.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="8"
                      >
                        How do I pay for products on this website?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="8">
                        <Card.Body>
                          Hubsquares is an online business directory. We help to
                          increase visibility of African businesses and make
                          them easily accessible to you, transactions cannot be
                          carried out on this website.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="9"
                      >
                        How can I complain about a business service I received?{" "}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="9">
                        <Card.Body>
                          If you are not happy with the quality of a service
                          from any of the registered vendors, we advice that you
                          use the rating system and leave honest reviews. If you
                          would like to make a complain, please do so via the
                          contact us page.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="10"
                      >
                        How do I contact your company if my question isn’t
                        answered here?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="10">
                        <Card.Body>
                          Please send us an email at hsqsupport@hubsquares.com
                          or visit the contact us page. We will endeavour to
                          respond within 3-5 working days.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </div>
                  <h3 className="my-3">FAQs for business owners</h3>
                  <div className="my-4">
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="11"
                      >
                        How can I sign up for an account?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="11">
                        <Card.Body>
                          To sign up as a business owner, please click on Join
                          now to register and login to your account, then ‘Add
                          Business to register your business.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="12"
                      >
                        How can I change my password?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="12">
                        <Card.Body>
                          After you have logged in click on profile to change
                          password.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="13"
                      >
                        What happens if I forget my password?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="13">
                        <Card.Body>
                          If you forget your password, please click ‘Forgot your
                          password’ link in the login page. The password
                          recovery email will be sent to the email address used
                          to register.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="14"
                      >
                        Do I need to have an account to register my business?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="14">
                        <Card.Body>
                          Yes. In order to register your business or add items
                          to the directory you must create an account.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="15"
                      >
                        How do I register my business?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="15">
                        <Card.Body>
                          Use the Sign up button to register and create an
                          account, then login into your account. Then click on
                          Add Business to create your business Hub.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="16"
                      >
                        How much is it to register my business on Hubsquares?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="16">
                        <Card.Body>
                          It is absolutely free for the first month and $2
                          monthly payment subsequently.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="17"
                      >
                        How do my potential clients contact me?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="17">
                        <Card.Body>
                          Your contact details will be made available on your
                          page if you are fully subscribed on the website.
                          Potential clients can easily access your contact
                          details and they would be directed to your social
                          media pages, WhatsApp or your website.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="18"
                      >
                        Why are my contact details hidden on my Hub?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="18">
                        <Card.Body>
                          To make your contact details visible on your Hub, you
                          need to be fully subscribed so potential customers can
                          get access to your contact details.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="19"
                      >
                        Can I cancel my subscription?{" "}
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="19">
                        <Card.Body>Yes, you can cancel at anytime.</Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="20"
                      >
                        How do I cancel my subscription?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="20">
                        <Card.Body>
                          We would hate to see you go but you can Login into
                          your Hub and from your dashboard, go to my business,
                          you can cancel your subscription.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="21"
                      >
                        If I cancel my subscription, would my account still be
                        active?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="21">
                        <Card.Body>
                          Yes, your account would still be live on Hubsquares
                          but your contact details would not be visible for
                          potential clients to reach you.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="22"
                      >
                        How do I know who has visited my Hub?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="22">
                        <Card.Body>
                          You can view daily analytics on your Hub and we will
                          send you analysis of how many people visited your Hub
                          weekly.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="23"
                      >
                        How do I delete my account completely?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="23">
                        <Card.Body>
                          Please send an email to hsqsupport@hubsquares.com
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card className="mb-2">
                      <Accordion.Toggle
                        as={Card.Header}
                        className="font-weight-bold"
                        eventKey="24"
                      >
                        How do I contact your company if my question isn’t
                        answered here?
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="24">
                        <Card.Body>
                          Please send us an email at hsqsupport@hubsquares.com
                          We will endeavour to respond within 3-5 working days.
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </div>
                </Accordion>
                <h4 className="text-center">
                  Can't find what you're looking for.{" "}
                  <Link className="text-black-50" to="/contact">
                    contact us
                  </Link>
                </h4>
              </div>
            )}
            {video && (
              <div className="my-5">
                <h3 className="mt-4">
                  YouTube videos on how to list your business{" "}
                </h3>
                <h4 className="mb-4">How to sign up on hubsquares</h4>
                <iframe width="560" height="315" src="https://www.youtube.com/embed/E0bYlPdgYFw" frameborder="0" title="sign up" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <h4 className="mt-4">How to list your business on hubsquares</h4>
                <iframe width="560"  title="sign up" height="315" src="https://www.youtube.com/embed/YuZwHIs1I_Y" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            )}
            <div className="position-relative py-3">
              <button
                className="text-white addbtn btn-danger btn  position-absolute bg-red"
                style={{
                  right: 0,
                }}
                onClick={() => window.scrollTo(0, 0)}
              >
                {/* <i class="fa fa-caret-up" aria-hidden="true"></i> */}
                Back to top
              </button>
            </div>
          </Container>
        </main>
      </main>
      <Footer />
    </div>
  );
}
